import {createReducer} from 'redux-act';
import {
  CLEAR_BAD_ORDER,
  GET_BAD_ORDER_SUCCESS,
  SET_BAD_ORDER_DETAIL_LOADING,
  UPDATE_BAD_STATUS
} from 'store/bookADriver/bookADriverDetails/action';

const initialState = () => ({
  order: {},
  isLoading: false
});

const bookADriverOpenDetails = createReducer(
  {
    [GET_BAD_ORDER_SUCCESS]: (state, payload) => ({
      ...state,
      order: payload,
      isLoading: false
    }),
    [SET_BAD_ORDER_DETAIL_LOADING]: (state, payload) => ({
      ...state,
      isLoading: payload
    }),
    [UPDATE_BAD_STATUS]: (state, payload) => {
      return {
        ...state,
        order: {
          ...state.order,
          data: {
            ...state.order.data,
            status: payload
          }
        }
      };
    },
    [CLEAR_BAD_ORDER]: (state) => ({
      ...state,
      order: {}
    })
  },
  initialState()
);

export default bookADriverOpenDetails;
